import styles from './invite-subproject.module.less';
import Input2 from '../../../components/input/input-2/Input2';
import RoundedButtonSecondary from '../../../components/button/rounded-button-secondary/RoundedButtonSecondary';
import RoundedButtonPrimary from '../../../components/button/rounded-button-primary/RoundedButtonPrimary';
import { deleteSubprojectInvite, updateSubprojectInvite } from './invite-subproject-actions';
import { useDispatch } from 'react-redux';
import { useState } from 'react';
import { validate } from './invite-model';

export const EditSubprojectInvite = ({ participant, projectId, onDelete, onUpdate }) => {
    const dispatch = useDispatch();
    const [currentName, setName] = useState(participant.name);
    const [currentEmail, setEmail] = useState(participant.email);
    const [errors, setErrors] = useState({});
    const [touched, setTouched] = useState({});
    const updateParticipant = () => {
        setTouched({ name: true, email: true });
        if (validateUser({})) {
            dispatch(
                updateSubprojectInvite({
                    id: participant.id,
                    projectId,
                    name: currentName,
                    email: currentEmail,
                })
            ).then((user) => {
                onUpdate({ participant: user });
            });
        }
    };

    const deleteParticipant = () => {
        dispatch(deleteSubprojectInvite({ projectId, invitedId: participant.id })).then(() => {
            onDelete({ participantId: participant.id });
        });
    };

    const validateUser = ({ name = currentName, email = currentEmail }) => {
        const errors = validate({ name: name, email: email });
        setErrors(errors);
        return Object.keys(errors).length === 0;
    };

    return (
        <div className={styles.editForm}>
            <label className={styles.editName}>
                <Input2
                    title="Navn"
                    value={currentName}
                    onChange={(e) => {
                        setName(e.target.value);
                        validateUser({ name: e.target.value });
                    }}
                    onBlur={() => setTouched({ ...touched, name: true })}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            updateParticipant();
                        }
                    }}
                    error={touched.name && errors.name}
                />
            </label>
            <label className={styles.editEmail}>
                <Input2
                    title="E-post"
                    value={currentEmail}
                    onChange={(e) => {
                        setEmail(e.target.value);
                        validateUser({ email: e.target.value });
                    }}
                    onKeyPress={(e) => {
                        if (e.key === 'Enter') {
                            updateParticipant();
                        }
                    }}
                    error={touched.email && errors.email}
                />
            </label>
            <RoundedButtonSecondary onClick={deleteParticipant} className={styles.deleteParticipant}>
                Slett
            </RoundedButtonSecondary>
            <RoundedButtonPrimary onClick={updateParticipant} className={styles.saveParticipant}>
                Lagre
            </RoundedButtonPrimary>
        </div>
    );
};
